module.exports = __webpack_public_path__ + "static/media/img8.733e56a5.jpg";